import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
interface AdminRouteProps {
  element: ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ element }) => {

  if (localStorage.getItem("is_admin") === "true") {
    return element;
  }

  return <Navigate to="/" replace />;

};

export default AdminRoute;
